import React, { FC, useState } from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';

import './SignIn.scss';

export const ForgotPasswordBox: FC<{ changeState: () => void }> = ({
  changeState,
}) => {
  const [resetRequestSent, setResetRequestSent] = useState(false);
  const [emailToReset, setEmailToReset] = useState('');
  const [resetRequestFailed, setResetRequestFailed] = useState(false);

  const emailInput = React.createRef<HTMLInputElement>();

  const getLoginUrl = () => {
    const path = window.location.pathname;
    const pathParts = path.split('/');
    pathParts[pathParts.length - 1] = 'sign-in';
    return [
      window.location.protocol,
      '//',
      window.location.host,
      pathParts.join('/'),
    ].join('');
  };

  const sendResetPasswordEmail = async event => {
    event.preventDefault();
    const emailAddress = emailInput.current.value.trim();
    setEmailToReset(emailAddress);

    setResetRequestSent(false);
    setResetRequestFailed(false);

    firebase
      .auth()
      .sendPasswordResetEmail(emailAddress, {
        url: getLoginUrl(),
      })
      .then(() => {
        // Email sent.
        setResetRequestSent(true);
      })
      .catch(error => {
        // An error happened.
        setResetRequestFailed(true);
        console.error('Error sending password reset email', error);
      });
  };
  return (
    <form className="container">
      <h2>Reset password</h2>

      <p>Submit your registered email to receive a password reset link.</p>

      <input
        ref={emailInput}
        className="form-email"
        autoComplete="email"
        type="text"
        name="email"
        placeholder="Email"
        autoCapitalize="none"
        autoCorrect="off"
      />
      <button onClick={async event => await sendResetPasswordEmail(event)}>
        Reset password
      </button>

      <button className="naked-button" onClick={changeState}>
        Back to sign in
      </button>

      {resetRequestSent && !resetRequestFailed && (
        <div className="password__alert__info">
          Email to reset password is sent to {emailToReset}.
        </div>
      )}
      {resetRequestFailed && (
        <div className="password__alert__info">
          There was an error resetting the password for email
          {emailToReset} . <br /> Try again or contact Porterbuddy.
        </div>
      )}
    </form>
  );
};
